<template>
    <header class="header">
        <nav class="inner">
            <div class="navWrap">
                <ul>
                    <li v-for="item in navi" :key="item.ID">
                        <ui-link :to="item.url" v-html="item.title"></ui-link>
                    </li>
                </ul>
            </div>

            <span class="mobile-trigger" @click="openMobileMenu">
                <svg viewBox="0 0 21 14">
                    <line x1="21" y1="0.9" x2="-7.18387e-08" y2="0.899998" />
                    <line x1="21" y1="6.9" x2="-7.18387e-08" y2="6.9" />
                    <line x1="21" y1="12.9" x2="-7.18387e-08" y2="12.9" />
                </svg>
            </span>
            <h1 class="logo">
                <router-link to="/">
                    <svg-icon name="logo" />
                </router-link>
            </h1>
        </nav>
    </header>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'Header',

    data() {
        return {
            navi: [],
        }
    },

    watch: {
        $route() {
            document.body.classList.remove('show-mobile-menu');
        }
    },

    components: {
        Link,
    },

    methods: {
        openMobileMenu() {
            document.body.classList.toggle('show-mobile-menu');
        },
    },

    mounted() {
        this.$ajax.get("/menus/15").then((res) => {
            this.navi = res.data.items;
        });
    }
}
</script>

<style lang="scss">
.header {

    .logo {
        padding: var(--padding-x4) 0;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            width: 48rem;
            height: 4.6rem;
            display: block;
            fill: var(--font-color);
        }

        a:hover {
            text-decoration: none;
        }
    }

    ul {
        display: flex;
        justify-content: space-evenly;
        padding: var(--padding-x2) 0;
        min-height: 3.8rem;

        li {
            text-align: center;

            a {
                color: var(--gray);
                text-transform: uppercase;

                &.router-link-active,
                &.router-link-exact-active,
                &:hover {
                    color: var(--font-color);
                }
            }
        }
    }

    .mobile-trigger {
        transition: transform .2s ease-in-out;
        display: none;
        position: fixed;
        z-index: 100000;
        right: var(--padding);
        top: 2.5vw;
        height: 3.2rem;
        width: 3.2rem;

        svg {
            fill: none;
            stroke: var(--font-color);
            height: 100%;
            width: 100%;

            line {
                stroke-width: 1.5;
                transition: .2s all ease;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .header {
        backdrop-filter: blur(10px);
        height: var(--padding-x3);
        position: fixed;
        width: 100vw;
        z-index: 9999;

        .inner {

            .logo {
                padding: 2rem 0;
                position: fixed;
                z-index: 99999;
                margin: 0 auto;
                width: calc(100% - var(--padding-x2));

                svg {
                    width: 28rem;
                    height: 2rem;
                    padding-bottom: 20px;
                }
            }

            .navWrap {
                position: fixed;
                top: 0;
                right: 0;
                width: 100%;
                height: 100vh;
                box-sizing: border-box;
                opacity: 0;
                visibility: hidden;
                display: flex;
                align-items: center;
                transition:
                    opacity 0.3s ease-in-out,
                    visibility 0.3s ease-in-out,
                    background-color 0.4s ease-in-out,
                    backdrop-filter 0.4s ease-in-out;
                z-index: 9999;

                ul {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                    padding: 0;
                    margin: 0;

                    li {
                        text-align: center;
                        margin: var(--padding);
                        font-size: var(--large-size);
                        width: 100%;
                    }
                }
            }

            .mobile-trigger {
                display: block;
            }
        }
    }

    .show-mobile-menu .header {
        backdrop-filter: none;

        .navWrap {
            opacity: 1;
            visibility: visible;
            background: rgba($color: #ffffff, $alpha: 0.7);
            backdrop-filter: blur(10px);
        }

        .mobile-trigger {

            svg {
                line:nth-child(1) {
                    transform: rotate(45deg) translate(10%, -25%);
                }

                line:nth-child(2) {
                    opacity: 0;
                }

                line:nth-child(3) {
                    transform: rotate(-45deg) translate(-39%, -2%);
                }
            }
        }
    }
}
</style>
